import { TopNavigation as TopNavigationShell } from '@mc/global-navigation'
import { Locations, ProductLine } from '@mc/track-event'
import { AtWorkLink } from 'components/Navigation/shared/AtWorkLink'
import { CertificatesLink } from 'components/Navigation/shared/CertificatesLink'
import { ExecutiveLink } from 'components/Navigation/shared/ExecutiveLink'
import { MasterClassLink } from 'components/Navigation/shared/MasterClassLink'
import { OnCallLink } from 'components/Navigation/shared/OnCallLink'
import { AllAccessNavLink } from '../../../../../experiments/prcng-897_v1_standalone-bundle'

export const TopNavigation = ({
  contained = false,
  className,
  showOnCallLink = false,
  showAtWorkLink = false,
  product = ProductLine.MASTERCLASS,
}: {
  contained?: boolean
  className?: string
  showOnCallLink?: boolean
  showAtWorkLink?: boolean
  product?: (typeof ProductLine)[keyof typeof ProductLine]
}) => (
  <TopNavigationShell as='nav' contained={contained} className={className}>
    <MasterClassLink
      className='mc-text-x-small mc-text--bold mc-ml-0'
      location={Locations.UTILITY_NAVIGATION}
      product={product}
    />
    <CertificatesLink
      className='mc-text-x-small mc-text--bold mc-ml-8'
      location={Locations.UTILITY_NAVIGATION}
      product={product}
    />
    {showOnCallLink && (
      <OnCallLink
        className='mc-text-x-small mc-text--bold mc-ml-8'
        location={Locations.UTILITY_NAVIGATION}
        product={product}
      />
    )}
    <ExecutiveLink
      className='mc-text-x-small mc-text--bold mc-ml-8'
      location={Locations.UTILITY_NAVIGATION}
      product={product}
    />
    {showAtWorkLink && (
      <AtWorkLink
        className='mc-text-x-small mc-text--bold mc-ml-8'
        location={Locations.UTILITY_NAVIGATION}
        product={product}
      />
    )}
    <AllAccessNavLink product={product} />
  </TopNavigationShell>
)
